import * as Api from "./api";

const VIPPS_CONNECT_API_URL = "/vipps/connect";
const VIPPS_CREATE_ACCOUNT_API_URL = "/vipps/create";
const VIPPS_CONNECT_GET_MATCHED_EMAILS_API_URL =
	"/vipps/connect/getMatchedEmails/";

export function connect(data) {
	return Api.postToApi(VIPPS_CONNECT_API_URL, data);
}

export function createAccount(data) {
	return Api.postToApi(VIPPS_CREATE_ACCOUNT_API_URL, data);
}

export function getMatchedEmails(vippsId) {
	return Api.getFromApi(
		`${VIPPS_CONNECT_GET_MATCHED_EMAILS_API_URL}${vippsId}`,
	);
}
